<script setup lang="ts">
/* eslint-disable max-len */
</script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path
      d="M15.768 11.759 9.239 1.67A1.476 1.476 0 0 0 8 1c-.501 0-.968.253-1.239.67L.232 11.76a1.442 1.442 0 0 0-.051 1.484c.258.467.753.757 1.29.757h13.057c.538 0 1.033-.29 1.291-.757a1.442 1.442 0 0 0-.051-1.484zM7.18 5.1c0-.443.363-.803.811-.803.448 0 .812.36.812.803v3.446a.807.807 0 0 1-.812.803.807.807 0 0 1-.811-.803V5.1zm.796 7.158a1.01 1.01 0 0 1-1.015-1.004 1.01 1.01 0 0 1 1.015-1.004c.56 0 1.015.45 1.015 1.004a1.01 1.01 0 0 1-1.015 1.004z"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </svg>
</template>
